"use client";

import { Search, MapPin, Truck, Gift } from "lucide-react";

export default function HowItWorks() {
  return (
    <section className="relative py-16 md:py-32 overflow-hidden bg-gradient-to-br via-green-50 dark:from-blue-950 dark:via-zinc-900 dark:to-green-900">
      {/* Floating Ghibli-inspired background emojis */}
      <div className="pointer-events-none select-none">
        <span className="absolute left-10 top-10 text-4xl opacity-30 animate-float1">
          ☁️
        </span>
        <span className="absolute right-16 top-24 text-3xl opacity-20 animate-float2">
          🍃
        </span>
        <span
          className="absolute left-1/2 bottom-10 text-5xl opacity-20 animate-float3"
          style={{ transform: "translateX(-50%)" }}
        >
          ✨
        </span>
        <span className="absolute left-1/4 top-1/2 text-2xl opacity-20 animate-float4">
          🌱
        </span>
      </div>
      <div className="mx-auto max-w-5xl px-6 relative z-10">
        <h2 className="text-balance text-4xl font-semibold lg:text-5xl text-center mb-12">
          How WeeKrt Works
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
          <div className="flex flex-col items-center bg-white/80 dark:bg-zinc-900/80 rounded-3xl shadow-xl p-6 transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl">
            <div className="bg-green-200 dark:bg-green-800 p-4 rounded-full mb-4 shadow-md">
              <Search className="size-10 text-green-600 dark:text-green-300" />
            </div>
            <h3 className="mt-4 text-lg font-bold text-green-800 dark:text-green-200">
              Find Products & Shops
            </h3>
            <p className="text-zinc-600 dark:text-zinc-300 text-sm">
              Search for any product and instantly discover the nearest local
              shops that offer it.
            </p>
          </div>
          <div className="flex flex-col items-center bg-white/80 dark:bg-zinc-900/80 rounded-3xl shadow-xl p-6 transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl">
            <div className="bg-blue-200 dark:bg-blue-800 p-4 rounded-full mb-4 shadow-md">
              <MapPin className="size-10 text-blue-600 dark:text-blue-300" />
            </div>
            <h3 className="mt-4 text-lg font-bold text-blue-800 dark:text-blue-200">
              Choose Delivery or Pickup
            </h3>
            <p className="text-zinc-600 dark:text-zinc-300 text-sm">
              Select home delivery for convenience, or pick up your order
              yourself from the nearest shop.
            </p>
          </div>
          <div className="flex flex-col items-center bg-white/80 dark:bg-zinc-900/80 rounded-3xl shadow-xl p-6 transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl">
            <div className="bg-yellow-200 dark:bg-yellow-800 p-4 rounded-full mb-4 shadow-md">
              <Truck className="size-10 text-yellow-600 dark:text-yellow-300" />
            </div>
            <h3 className="mt-4 text-lg font-bold text-yellow-800 dark:text-yellow-200">
              Fast Local Delivery
            </h3>
            <p className="text-zinc-600 dark:text-zinc-300 text-sm">
              Get groceries and products from your favorite local markets
              delivered right to your doorstep.
            </p>
          </div>
          <div className="flex flex-col items-center bg-white/80 dark:bg-zinc-900/80 rounded-3xl shadow-xl p-6 transition-transform duration-300 hover:-translate-y-2 hover:shadow-2xl">
            <div className="bg-purple-200 dark:bg-purple-800 p-4 rounded-full mb-4 shadow-md">
              <Gift className="size-10 text-purple-600 dark:text-purple-300" />
            </div>
            <h3 className="mt-4 text-lg font-bold text-purple-800 dark:text-purple-200">
              Earn WeeCoins
            </h3>
            <p className="text-zinc-600 dark:text-zinc-300 text-sm">
              Collect WeeCoins on every purchase and redeem them for exciting
              rewards and discounts.
            </p>
          </div>
        </div>
      </div>
      <style jsx global>{`
        @font-face {
          font-family: "ghibli";
          src: local("Comic Sans MS"), local("Comic Sans"), local("Chalkboard"),
            sans-serif;
        }
        .font-ghibli {
          font-family: "ghibli", "Comic Sans MS", "Chalkboard", cursive,
            sans-serif;
          letter-spacing: 0.01em;
        }
        .animate-float1 {
          animation: float1 7s ease-in-out infinite;
        }
        .animate-float2 {
          animation: float2 9s ease-in-out infinite;
        }
        .animate-float3 {
          animation: float3 11s ease-in-out infinite;
        }
        .animate-float4 {
          animation: float4 8s ease-in-out infinite;
        }
        @keyframes float1 {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-24px);
          }
        }
        @keyframes float2 {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(18px);
          }
        }
        @keyframes float3 {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-30px);
          }
        }
        @keyframes float4 {
          0%,
          100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-12px);
          }
        }
      `}</style>
    </section>
  );
}
